import { combineReducers } from 'redux'

import { Reducer as ui } from './ui'
import { Reducer as skus } from './modules/skus'

export default () =>
  combineReducers({
    ui,
    skus
  })
